export default {
  field: 'id',
  type: 'integer',
  datatype: 'int',
  interface: 'primary_key',
  primary_key: true,
  auto_increment: true,
  length: 10,
  signed: false
}
